import { render } from "./Messages.vue?vue&type=template&id=5495a2c8&scoped=true"
import script from "./Messages.vue?vue&type=script&lang=js"
export * from "./Messages.vue?vue&type=script&lang=js"

import "./Messages.vue?vue&type=style&index=0&id=5495a2c8&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-5495a2c8"

export default script